import React, { ReactElement } from 'react';
import './aktualitaListGrid.scss';
import AktualitaOverviewItem from './AktualitaOverviewItem';
import Aktualita from '../../../../model/Aktualita';

interface Props {
  aktualitaList?: Aktualita[];
}

const AktualitaListGrid = ({
  aktualitaList,
}: Props): ReactElement => (
  <>
    <div className="aktualita-list-grid">
      {aktualitaList?.map((aktualita) => (
        <div key={aktualita.id}>
          <AktualitaOverviewItem aktualita={aktualita} />
        </div>
      ))}
    </div>
  </>
);

export default AktualitaListGrid;
